const plates = require("./plates")
const deliveryPrices = require("./delivery-prices")
const { docs } = require("./docs")
const { licenses } = require("./licenses")
const { comprehensiveInsurance } = require("../multi-city/comprehensive-insurance")

const abuja = {
  city: "abuja",
  areas: [],
  plates,
  docs,
  licenses,
  testingCenters: [],
  deliveryPrices,
  comprehensiveInsurance,
}

module.exports = abuja
